import React from 'react'
import Header from '../Header/Main'
import Breadcrumb from '../Breadcrumb/Main'
import EnterpriseAppDevelopment from '../MenserviceEnterpriseAppDevelopment/EnterpriseAppDevelopment'
import Footer from '../Footer/Main'

function Main() {
    return (
        <>
            <div className="page-wrapper">
                <Header />
                <Breadcrumb subtitle="Home" title="Enterprise App Development" />
                <EnterpriseAppDevelopment />
                <Footer />
            </div>
        </>
    )
}

export default Main